import { DOMUtils } from '../../../../utils/dom'
import { AbstractWidgetAdapter, IWidgetAdapter } from '../adapter'

interface IWindow extends Window {
    F2: any
}

interface IAppConfig {
    appId: string,
    manifestUrl: string
    selector: string
}

interface IStock {
    exchange: string
    symbol: string

}

declare let window: IWindow

export class Markets extends AbstractWidgetAdapter implements IWidgetAdapter {

    public static DOM = {
        attrs: {
            markets: 'data-markets',
        }
    }

/*
	Helper function to dynamically build the apps for the container
*/

    private readonly ManifestUrl = 'https://financialpost.markitondemand.com/F2/Apps'
    private markitAppConfig: IAppConfig[] = [
        {
            appId: 'com_financialpost_trendingsymbol',
            manifestUrl: this.ManifestUrl,
            selector: 'appTrendingSymbol'
        },
        {
            appId: 'com_financialpost_marketstoday',
            manifestUrl: this.ManifestUrl,
            selector: 'appMarketsToday'
        },
        {
            appId: 'com_financialpost_equitiesoverview',
            manifestUrl: this.ManifestUrl,
            selector: 'appEquitiesOverview'
        },
        {
            appId: 'com_financialpost_commoditiesoverview',
            manifestUrl: this.ManifestUrl,
            selector: 'appCommoditiesOverview'
        },
        {
            appId: 'com_financialpost_currenciesoverview',
            manifestUrl: this.ManifestUrl,
            selector: 'appCurrencyOverview'
        }
    ]

    public constructor(public el: Element, public adLight = false) {
        super(el, adLight)
    }

    public static GetQueryVariable(variable: string) {
        const path = window.location.pathname
        const urlParts = path.split('/')
        const loc = urlParts.indexOf(variable)
        return urlParts[loc + 1]
    }

    public loadData(): void {
        const scriptSrc = '//cdnjs.cloudflare.com/ajax/libs/F2/1.4.5/f2.min.js'
        const commonScriptSrc = 'https://financialpost.markitondemand.com/Content/Dist/Scripts/common.min.js'
        DOMUtils.loadScript(commonScriptSrc)
        const script = document.createElement('script')
        script.src = scriptSrc
        script.onload = this.render.bind(this)
        document.head.appendChild(script)
    }

    public render(): void {
        const token = window.F2.AppHandlers.getToken()

        // check the querystring to see if there are params for initial load
        const params = {
            exchange: Markets.GetQueryVariable('exchange'),
            symbol: Markets.GetQueryVariable('symbol')
        }

        // init F2
        window.F2.init()
        // ensure only one F2 container exists on the page
        window.F2.registerApps(this.getAppConfig(params))
        // window.F2.registerApps(this.markitAppConfig)
        // render the app by inserting the html into the placeholder/root
        window.F2.AppHandlers.on(token, 'appRender',
            (appConfig: { selector: string; root: HTMLDivElement; instanceId: string; appId: string },
             appHtml: string) => {
            // container is based on selector passed by appConfig
            const container = document.querySelector('#' + appConfig.selector)
            // build unique root element and place appHtml inside
            appConfig.root = document.createElement('div')
            appConfig.root.setAttribute('id', 'root_' + appConfig.instanceId)
            appConfig.root.setAttribute(
                'class',
                'panel-body app-root app-wrapper MOD' + appConfig.appId
            )
            appConfig.root.innerHTML = appHtml

            // append the new app to the container
            container.appendChild(appConfig.root)
        })
    }

    private getAppConfig(params: IStock) {
        if (params.exchange && params.symbol) {
            return [
                {
                    appId: 'com_financialpost_companysnapshot',
                    context: {
                        exchange: params.exchange,
                        symbol: params.symbol,
                        type: 'stock'
                    },
                    manifestUrl: this.ManifestUrl,
                    selector: 'appCompanySnapshot'
                },
                {
                    appId: 'com_financialpost_performancechart',
                    context: params,
                    manifestUrl: this.ManifestUrl,
                    selector: 'appPerformanceChart'
                }
            ]
        } else {
            return this.markitAppConfig
        }
    }
}
